import ssoImg1 from "./../../../../assets/images/licence-img.png"; // Adjust the path as necessary
import pdfIcon from "./../../../../assets/images/pdf.png"; // Adjust the path as necessary
import Doc1 from "./../../../../Documents/Licensing/Registration of sport and rec pleasure vessels.pdf";
import Doc2 from "./../../../../Documents/Licensing/Registration_of_sport_and_rec_pleasure_vessels.pdf";

function SmallVesselsSafetyLicensingTab() {
  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        Small vessels safety{" "}<br/>
        <span className="text-orange-ef3e33 font-400"> Licensing </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-4 g-lg-0">
        <div className="col-lg">
          <div className="pe-lg-4">
            <p className="mb-4">
            The Merchant Shipping Act 57 of 1951(sections 68 to 72) requires
            some vessels to be Licensed. The Act requires that vessels that are
            not registered must have a license.
          </p>

          <p className="mb-4">
            This applies to both Inland and Sea-going vessels. It is a
            requirement to hold a valid LGSC before a license is issued. The
            Ship Registration Act excludes foreign vessels from holding a
            license.
          </p>

          <p className="mb-4">
            Vessels used solely for pleasure are exempted from licensing, but
            are generally (except for exempted vessels) required to be
            inspected, have an approved identification number issued, have
            Certificates of Fitness issued, and skippers of certain types of
            vessel are to be certificated, the authority may designate any or
            all of these functions to an “Authorised Agency”.
          </p>
          </div>
          {/* <ul className="strip-ul mt-4">
            <li>
              <div className="row g-4">
                  <div className="col-auto"><img src={pdfIcon} alt="" /></div>
                  <div className="col-4">
                    <div className="font-18 font-600">File Name</div>
                    <div className="font-16 font-400">Registration of sport and rec pleasure vesssels</div>
                  </div>
                  <div className="col-3">
                    <div className="font-18 font-600">Modified</div>
                    <div className="font-16 font-400">2019/08/05 10.35 AM</div>
                  </div>
              </div>
            </li>
            <li>
              <div className="row g-4">
                  <div className="col-auto"><img src={pdfIcon} alt="" /></div>
                  <div className="col-4">
                    <div className="font-18 font-600">File Name</div>
                    <div className="font-16 font-400">Registration of sport and rec pleasure vesssels</div>
                  </div>
                  <div className="col-3">
                    <div className="font-18 font-600">Modified</div>
                    <div className="font-16 font-400">2019/08/05 10.35 AM</div>
                  </div>
              </div>
            </li>
            
          </ul> */}
          <div className="accordion blackTab" id="blackTab">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabOne"
                  aria-expanded="false"
                  aria-controls="blackTabOne"
                >
                  REGISTRATION  OF SPORT AND REC PLEASURE VESSELS
                </button>
              </h2>
              <div
                id="blackTabOne"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  {/* <p className="mb-3">Process, including the process flow and identification of the role players</p> */}

                  <ul class="green-star-ul">
                    <li><a href={Doc1}>Registration_of_sport_and_rec_pleasure_vessels</a></li>
                    <li><a href={Doc2}>Registration of sport and rec pleasure vessels</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>


        </div>
        {/* <div className="col-lg-5">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div> */}
        
      </div>
    </>
  );
}

export default SmallVesselsSafetyLicensingTab;
